export default __webpack_public_path__ + "static/media/nlr-image.591d220d.png";